import { ArrowRight, KeyRound } from 'lucide-react';

const ENABLE_URL = 'https://satutim.id/settings/api?return=playground';

interface Props {
    variant?: 'card' | 'banner';
    title?: string;
    description?: string;
}

export default function ConnectCta({
    variant = 'banner',
    title = 'Login dengan SatuTim untuk pakai fitur ini',
    description = 'Aktifkan akses API di pengaturan workspace, lalu kembali ke sini. API key kamu akan auto-sync.',
}: Props) {
    if (variant === 'card') {
        return (
            <section className="p-5 rounded-xl" style={{ backgroundColor: 'var(--surface-1)', border: '1px solid var(--border)' }}>
                <div className="flex items-start gap-3">
                    <div className="h-10 w-10 rounded-lg flex items-center justify-center shrink-0" style={{ backgroundColor: 'var(--surface-2)', border: '1px solid var(--border)' }}>
                        <KeyRound className="h-4 w-4 text-ghost" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <h2 className="text-sm font-semibold text-ink mb-1">{title}</h2>
                        <p className="text-xs text-muted leading-relaxed mb-3">{description}</p>
                        <a
                            href={ENABLE_URL}
                            className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-md transition-colors"
                            style={{ backgroundColor: 'var(--accent)', color: 'var(--bg)' }}
                        >
                            Login dengan SatuTim <ArrowRight className="h-3 w-3" />
                        </a>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <div
            className="mb-6 px-4 py-3 rounded-lg flex flex-col sm:flex-row sm:items-center gap-3"
            style={{ backgroundColor: 'var(--accent-bg)', border: '1px solid var(--accent-border)' }}
        >
            <div className="flex items-start gap-3 flex-1 min-w-0">
                <KeyRound className="h-4 w-4 text-accent shrink-0 mt-0.5" />
                <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-ink leading-tight">{title}</p>
                    <p className="text-xs text-muted mt-0.5 leading-relaxed">{description}</p>
                </div>
            </div>
            <a
                href={ENABLE_URL}
                className="shrink-0 inline-flex items-center justify-center gap-1.5 text-xs font-semibold px-3 py-2 rounded-md transition-colors hover:opacity-90 w-full sm:w-auto"
                style={{ backgroundColor: 'var(--accent)', color: 'var(--bg)' }}
            >
                Login dengan SatuTim <ArrowRight className="h-3 w-3" />
            </a>
        </div>
    );
}
